module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');
	    var ToastrController = new (require('./services/ToastrController'));

        var $button = $('#generate_geo_codes_from_postcode');

	    $button.on('click', function(e){
            var $this = $(this),
                postcode = $('#postcode').val(),
                latitudeField = $('#geo_latitude'),
		        longitudeField = $('#geo_longitude'),
                url = '/api/external/generate-geo-codes-from-postcode',
                data;

            e.preventDefault();

            data = {
                postcode: postcode,
            };

            /** Define error callback */
            var success = function (response) {
	            latitudeField.val(response.result.latitude)
	            longitudeField.val(response.result.longitude)
            }

            /** Define error callback */
            var error = function (response) {
                console.log('Error');
            }

            if(!postcode){
	            ToastrController.showDanger('There is no postcode!');
            } else{
	            /** Send AJAX request */
	            AjaxController.prototype.send(url, data, success, error);
            }

        });

    });
}();
